import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, first, map, switchMap } from 'rxjs/operators';
import { LearningCenterManagementService } from '../../learning-center-management/learning-center-management.service';
import { of } from 'rxjs';
import { LearningCenterService } from '../learning-center.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
  SwiperOptions,
  EffectCoverflow,
} from 'swiper';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

SwiperCore.use([
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
  EffectCoverflow,
]);

@Component({
  selector: 'app-learning-center-detail',
  templateUrl: './learning-center-detail.component.html',
  styleUrls: ['./learning-center-detail.component.scss']
})
export class LearningCenterDetailComponent implements OnInit {
  centerId: string = '';
  centerDetail: any;
  main_theme: any;

  allNews: any[] = [];
  allArticles: any[] = [];
  allCourse: any[] = [];
  allWorkshop: any[] = [];
  allMeasure: any[] = [];

  customOptions: SwiperOptions = {
    // autoplay: {
    //   delay: 2000,
    //   disableOnInteraction: false
    // },
    speed: 800,
    loop: false,
    grabCursor: true,
    slidesPerView: 3,
    autoHeight: true,
    pagination: { clickable: true, },
    navigation: false,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      }
    }
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private learningManagementCenterService: LearningCenterManagementService,
    private learningCenterService: LearningCenterService,
    private gobalFunctionService: GobalFunctionService,
  ) { }

  ngOnInit(): void {
    this.centerId = new URL(location.href).searchParams.get('id');
    this.route.params.pipe(
      first(),
      map(params => {
        this.centerId = params['id'];
        this.getLearningCenter(this.centerId);
      })
    ).subscribe();

  }

  getLearningCenter(centerId) {
    this.learningManagementCenterService.getLearningCenter(centerId).pipe(
      map(ln => {
        this.centerDetail = ln.result[0];
        this.gobalFunctionService.setSEO(this.centerDetail.CENTER_NAME, 'website', this.centerDetail.CENTER_DESCRIPTION);
        this.getTheme(this.centerDetail.THEME_ID);
        this.getAllTAG(centerId);
      }),
      catchError(err => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
  }

  getTheme(themeId) {
    let _theme;
    this.learningManagementCenterService.getLearningTheme().pipe(
      map(theme => {
        _theme = theme.result.filter(th => themeId === th.THEME_ID);
        this.main_theme = _theme[0];

      })
    ).subscribe();
  }

  getAllTAG(centerId) {
    this.learningCenterService.getAllNews(centerId).pipe(
      switchMap(news => {
        if (news.success) {
          this.allNews = news.result;

          return this.learningCenterService.getAllArticle(centerId).pipe(
            switchMap(articles => {
              this.allArticles = articles.result;

              return this.learningCenterService.getAllCourse(centerId).pipe(
                switchMap(courses => {
                  this.allCourse = courses.result;

                  return this.learningCenterService.getAllWorkshops(centerId).pipe(
                    switchMap(workshops => {
                      this.allWorkshop = workshops.result;

                      return this.learningCenterService.getAllMeasure(centerId).pipe(
                        map(measure => {
                          this.allMeasure = measure.result;
                        })
                      )
                    })
                  )
                })
              )
            })
          )
        }
      }),
      catchError(err => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
  }

  viewCourse(cid) {
    window.open(`/e-learning/${cid}`, '_self');
  }
}
